import { NgModule } from '@angular/core';
import { IconButtonComponent } from './icon-button.component';

@NgModule({
  declarations: [],
  imports: [IconButtonComponent],
  exports: [IconButtonComponent],
})
export class IconButtonModule {}
